import angular from 'angular';

/* eslint indent: "off" */
const teamService = angular.module('ttb.services.configuration.team.service', [])
  .factory('teamService', ['$q', '$http',
    ($q, $http) => {
      const url = '/api/configuration/team';

      let items;
      const itemCache = {};

      const clearCache = (id) => {
        items = null;
        itemCache[id] = null;
      };

      const query = (filter) => {
        const { q, groupId, projects, userId } = filter || {};
        return $q((resolve, reject) => {
          if (items && !filter) {
            resolve(items);
            return;
          }
          $http.get(url, { params: { q, groupId, projects, userId } })
            .then((response) => {
              if (DEBUG) {
                console.log(response);
              }
              if (!filter) {
                items = response.data;
              }
              resolve(response.data);
            }, reject);
        });
      };

      const get = ({ id }) => $q((resolve, reject) => {
        if (itemCache[id]) {
          resolve(itemCache[id]);
          return;
        }
        $http.get(`${url}/${id}`)
          .then((response) => {
            if (DEBUG) {
              console.log(response);
            }
            itemCache[id] = response.data;
            resolve(itemCache[id]);
          }, reject);
      });

      const getTemplate = ({ companyId, projectId }) => $q((resolve, reject) => {
        $http.get(`${url}/template?companyId=${companyId}&projectId=${projectId}`)
          .then((response) => {
            if (DEBUG) {
              console.log(response);
            }
            resolve(response.data);
          }, reject);
      });

      const upset = ({
        teamId,
        name,
        effortCost,
        isActive,
        startDate,
        description,
        projectId,
        workingTimings,
        workingDayInherit,
        costOfEstimationUnit,
        costOfEstUnitInherit
      }) => $q((resolve, reject) => {
          $http.post(url,
            {
              teamId,
              name,
              effortCost,
              isActive,
              startDate,
              description,
              projectId,
              workingDayInherit,
              workingTimings,
              costOfEstimationUnit,
              costOfEstUnitInherit
            })
            .then((response) => {
              clearCache(teamId);
              resolve(response.data);
            }, reject);
        });

      const isTeamExists = (projectId, teamName, teamId) => $q((resolve, reject) => {
          $http.get(`${url}/is-exists?teamId=${teamId}&projectId=${projectId}&teamName=${teamName}`)
              .then((response) => {
                  resolve(response.data);
              }, reject);
      });

      return {
        query,
        get,
        getTemplate,
        upset,
        isTeamExists
      };
    }])
  .name;

export default teamService;




// WEBPACK FOOTER //
// ../services/configuration/team.service.js